const MAX_TEAM_NAME_LENGTH = 9;

export const getTeamShortName = (teamName: string): string =>
  teamName.length > MAX_TEAM_NAME_LENGTH
    ? teamName.slice(0, MAX_TEAM_NAME_LENGTH) +
      (teamName[MAX_TEAM_NAME_LENGTH] !== " " ? "." : "")
    : teamName;
